// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SignUpModal_wrapper__TstO4","form":"SignUpModal_form__KE9BN","fields":"SignUpModal_fields__n_jzR","errorText":"SignUpModal_errorText__JRKQA"};